import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=52268ea0&"
import script from "./AboutCard.vue?vue&type=script&lang=js&"
export * from "./AboutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports